/** 베타 테스터 노트 — 미전송 초안 로컬 임시저장 */

export type BetaTesterFeedbackDraft = {
  goodPoints: string;
  useCases: string;
  improvements: string;
  bugs: string;
};

export const EMPTY_BETA_TESTER_FEEDBACK_DRAFT: BetaTesterFeedbackDraft = {
  goodPoints: '',
  useCases: '',
  improvements: '',
  bugs: '',
};

const STORAGE_PREFIX = 'cp.betaTesterFeedback.draft.v1';

function storageKey(userId: string | null | undefined): string {
  const uid = (userId ?? '').trim() || 'anon';
  return `${STORAGE_PREFIX}.${uid}`;
}

function clampField(value: unknown): string {
  return typeof value === 'string' ? value.slice(0, 5000) : '';
}

export function loadBetaTesterFeedbackDraft(
  userId?: string | null,
): BetaTesterFeedbackDraft {
  if (typeof window === 'undefined') return { ...EMPTY_BETA_TESTER_FEEDBACK_DRAFT };
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return { ...EMPTY_BETA_TESTER_FEEDBACK_DRAFT };
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return {
      goodPoints: clampField(parsed.goodPoints),
      useCases: clampField(parsed.useCases),
      improvements: clampField(parsed.improvements),
      bugs: clampField(parsed.bugs),
    };
  } catch {
    return { ...EMPTY_BETA_TESTER_FEEDBACK_DRAFT };
  }
}

export function saveBetaTesterFeedbackDraft(
  draft: BetaTesterFeedbackDraft,
  userId?: string | null,
): void {
  if (typeof window === 'undefined') return;
  try {
    const payload: BetaTesterFeedbackDraft = {
      goodPoints: clampField(draft.goodPoints),
      useCases: clampField(draft.useCases),
      improvements: clampField(draft.improvements),
      bugs: clampField(draft.bugs),
    };
    const empty =
      !payload.goodPoints &&
      !payload.useCases &&
      !payload.improvements &&
      !payload.bugs;
    const key = storageKey(userId);
    if (empty) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, JSON.stringify(payload));
  } catch {
    /* quota 등 무시 */
  }
}

export function clearBetaTesterFeedbackDraftField(
  key: keyof BetaTesterFeedbackDraft,
  userId?: string | null,
): void {
  const current = loadBetaTesterFeedbackDraft(userId);
  saveBetaTesterFeedbackDraft({ ...current, [key]: '' }, userId);
}
